import { useEffect } from 'react';
import { useConsent } from '~/core/consent/ConsentProvider';
import { UserSession } from '~/core/session/types/user-session';
import {
  initializeBrowserSentry,
  setBrowserSentryUser,
  stopBrowserSentry,
} from '~/core/sentry/initialize-browser-sentry';

/** Tie browser error monitoring to the visitor's current opt-in choice. */
export function useSentry(userSession?: Maybe<UserSession>) {
  const auth = userSession?.auth;
  const userId = auth?.uid;
  const userEmail = auth?.email;
  const userName = auth?.displayName;
  const { choice, ready } = useConsent();
  const allowed = ready && choice?.diagnostics === true;
  const diagnosticsGrantId = choice?.diagnosticsGrantId;

  useEffect(() => {
    if (!allowed) {
      void stopBrowserSentry();
      return;
    }

    let active = true;
    void initializeBrowserSentry()
      .then((started) => {
        if (!active || !started) return;
        setBrowserSentryUser(
          userId
            ? {
                id: userId,
                email: userEmail ?? undefined,
                username: userName ?? undefined,
              }
            : null,
        );
      })
      .catch(() => {
        // Error reporting is optional; it must not interrupt the page.
      });

    return () => {
      active = false;
    };
  }, [allowed, diagnosticsGrantId, userId, userEmail, userName]);
}
